module.exports = __webpack_public_path__ + "media/images/fansavesLogo-016d6bd7.jpeg";